export const getCategories = (state) => state.categories.categories
export const getCategoriesIsLoading = (state) => state.categories.isLoading